import PropTypes from 'prop-types';
import V360Loader from './V360Loader';
import css from './V360Loader.scss';

V360Loader.displayName = 'V360Loader';

const classes = {
	root: css.v360Loader,
	button: css.v360LoaderButton,
	buttonLabel: css.v360LoaderButtonLabel,
	buttonAtivar: css.v360LoaderButtonAtivar,
	buttonIcon: css.v360LoaderButtonIcon,
	buttonIconImage: css.v360LoaderButtonIconImage,
	buttonIconProgress: css.v360LoaderButtonIconProgress,
	isWaiting: css.isWaiting,
	isDone: css.isDone,
};

V360Loader.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	mobile: PropTypes.bool,
	label: PropTypes.string,
	started: PropTypes.bool,
	display: PropTypes.bool,
};

V360Loader.defaultProps = {
	className: '',
	classes,
	mobile: true,
	label: 'Arraste',
	started: false,
	display: false,
};

export { V360Loader };
export default V360Loader;
